<div class="filter-chip-wrapper">
  <div [ngClass]="{ 'search-filter-wrapper': filterOptions?.enableSearchFilterToggle }">
    <div class="search-filter-inner" [ngClass]="{ 'search-filter-with-toggle': filterOptions?.enableSearchFilterToggle }">
      <form #form="ngForm" (ngSubmit)="submitSearch()">
        @if (filterOptions?.showSearch) {
        <mat-list-item class="search-filter shadow" [ngClass]="{ 'has-search': searchQuery?.value?.length > 0 }">
          @if (searchQuery?.value?.length > 0) {
          <mat-icon (click)="clearSearch()" class="prefix-icon" slot="start">close</mat-icon>
          }
          <input class="search-input" matInput type="text" placeholder="Search Device" name="searchQuery" [formControl]="searchQuery" />
          <mat-icon (click)="submitSearch()" class="suffix-icon" slot="end">search</mat-icon>
        </mat-list-item>
        }
        <button mat-button type="submit" hidden></button>
      </form>
    </div>
    @if (filterOptions?.enableAddButton) {
    <div (click)="searchFilterToggle()">
      <button class="btn primary-btn" (click)="addItem()">Add</button>
    </div>
    }
    <!-- <div (click)="searchFilterToggle()" *ngIf="filterOptions?.enableSearchFilterToggle" class="search-filter-toggle">
      <mat-icon  svgIcon="assets/icon/searchfiltertoggle.svg"></mat-icon>
    </div> -->
  </div>

  <div class="filter-hint-wrapper">
    @if (filterOptions.filterHint != null) {
    <mat-label class="filter-hint">{{ filterOptions.filterHint }}</mat-label>
    }
  </div>

  <div
    [ngClass]="{
      'search-chips-wrapper': filterOptions?.enableChipsMinimizeToggle || filterOptions?.enableChipsSortToggle
    }"
  >
    @if (filterOptions?.enableChipsSortToggle) {
    <div class="search-chips-sort-toggle" (click)="chipsSortToggle()">
      <mat-icon><img src="assets/icon/sort.svg" /></mat-icon>
    </div>
    } @if (filterOptions?.showClearChip) {
    <div class="clear-chips-wrapper">
      <mat-chip (click)="clear()" class="filter-chip shadow filter-chip-inactive">
        <mat-label>X</mat-label>
      </mat-chip>
    </div>
    }

    <div class="scrolling-wrapper-flexbox">
      @for (chip of filterChips; track chip) {
      <mat-chip
        (click)="toggleChip(chip)"
        class="filter-chip shadow"
        [ngClass]="chip.isSelected == null || chip.isSelected == false ? 'filter-chip-inactive' : 'filter-chip-active'"
      >
        <mat-label>{{ chip.title }}</mat-label>
      </mat-chip>
      }
    </div>

    @if (filterOptions?.enableChipsMinimizeToggle) {
    <div (click)="chipsMinimizeToggle()" class="search-chips-min-toggle">
      <mat-icon><img src="assets/icon/togglemin.svg" /></mat-icon>
    </div>
    }
  </div>

  <div class="clear-chip-wrapper"></div>

  @if (showAdvancedFilter) {
  <app-advanced-filter-container [deviceFilter]="deviceFilter"></app-advanced-filter-container>
  }
</div>
